import { RefObject, useEffect, useRef } from 'react'

const useScrollLoading = (
  scrollElem: RefObject<HTMLDivElement | null>,
  eventCallback: () => void,
  dependencies: Array<any>
): void => {
  const eventCallbackRef = useRef(eventCallback)

  useEffect(() => {
    eventCallbackRef.current = eventCallback
  }, [eventCallback])

  useEffect(() => {
    const scrollEventCallback = () => {
      if (!scrollElem.current) return
      const position = scrollElem.current.getBoundingClientRect()
      if (position.bottom - window.innerHeight < 400) {
        eventCallbackRef.current()
      }
    }

    // Capture scroll events from nested scroll containers as well
    document.addEventListener('scroll', scrollEventCallback, {
      capture: true,
      passive: true
    })
    window.addEventListener('resize', scrollEventCallback)

    return () => {
      document.removeEventListener('scroll', scrollEventCallback, true)
      window.removeEventListener('resize', scrollEventCallback)
    }
  }, [...dependencies])
}

export default useScrollLoading
